import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { mockProducts } from '../mockData';

const Products = () => {
  return (
    <section id="products" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Complete Payment Solutions — Built Around Your Business
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From Card Machines to Pay by Link and Online Payments, eCOMM brings everything together in one seamless platform so you can spend less time managing payments and more time serving your customers.
          </p>
        </div>

        <div className="space-y-28">
          {mockProducts.map((product, index) => (
            <div
              key={product.id}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-12 lg:gap-16 items-center`}
            >
              {/* Image — elevated/floating card */}
              <div className="flex-1 w-full">
                <div className="relative group">
                  {/* Soft brand glow behind */}
                  <div
                    aria-hidden="true"
                    className="absolute -inset-4 bg-gradient-to-br from-[#0E88A3]/25 via-[#1F4E79]/15 to-transparent rounded-[2rem] blur-2xl opacity-70 group-hover:opacity-100 transition-opacity duration-500"
                  />
                  {/* Bottom drop shadow plate */}
                  <div
                    aria-hidden="true"
                    className="absolute inset-x-6 -bottom-4 h-8 rounded-full bg-black/20 blur-2xl opacity-60 group-hover:opacity-80 group-hover:-bottom-5 transition-all duration-500"
                  />
                  <div className="relative overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-black/5 transform transition-all duration-500 group-hover:-translate-y-1 group-hover:shadow-2xl">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-[400px] object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {product.title}
                </h3>
                <p className="text-lg text-gray-600 mb-6">
                  {product.description}
                </p>

                {/* Features as tag pills */}
                <div
                  className="flex flex-wrap gap-2 mb-8"
                  data-testid={`product-${product.id}-features`}
                >
                  {product.features.slice(0, 4).map((feature, idx) => (
                    <span
                      key={idx}
                      className="inline-flex items-center px-4 py-2 rounded-full bg-[#0E88A3]/10 text-[#0E5F73] text-sm font-medium tracking-wide"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                <Button
                  asChild
                  className="bg-[#1F4E79] hover:bg-[#163a5f] text-white"
                  size="lg"
                  data-testid={`product-${product.id}-learn-more`}
                >
                  <Link to={product.route} state={{ from: '/' }}>Learn More</Link>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
